'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.monthsUntil;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/monthsUntil.js
// module id = 580
// module chunks = 0